
import React from "react";
import { Name } from "../../../lib/prm/name";
import { Text } from "../../../lib/prm/text";
import { FlowRender } from "../../../lib/flow-render";
import { loadUserPersonalData, saveUserPersonalData } from "../User/actions";
import {DashboardContainer, GreyBox} from "../../funcs/utils";
import { Spinner, Action } from "../../funcs/utils";
import { deep_copy } from "../../../lib/js-utils";
import { SetPasswordDialog } from "./set-password-dialog";
import { DEVICE } from "../../../lib/constants";

const ADDRESS = new Text(new Name("role_0_street", "Address"));
const ADDRESS_2 = new Text(new Name("role_0_address", "Address"));
const CITY = new Text(new Name("role_0_city", "City"));
const STATE = new Text(new Name("role_0_state", "State"));
const ZIP = new Text(new Name("role_0_zip", "Zip"));
const PHONE = new Text(new Name("role_0_phone_number", "Phone"));
const SS = new Text(new Name("role_0_ss"));
const EMAIL = new Text(new Name("role_0_email"));

const ALL_PRMS = new FlowRender(0, [
  ADDRESS,
  ADDRESS_2,
  CITY,
  STATE,
  ZIP,
  PHONE,
  SS,
  EMAIL,
]);

class PersonalInfoDashboard extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      saving: false,
      dirty: false,
      show_password_popup: false,
    }
  }

  doSmallLayout = () => {
    const device = this.props.app.device;
    return device === DEVICE.small ||
      device === DEVICE.tiny ||
      device === DEVICE.medium;
  }

  componentDidMount = () => {
    this.setState({loading: true});
    loadUserPersonalData(this.props.token, this.props.username)
      .then((result) => {
        const state = deep_copy(this.state);
        ALL_PRMS.init(state, result, this);
        state.loading = false;
        this.setState(state);
      })
  }

  onSave = () => {
    const data = ALL_PRMS.saveToState(this.state);
    const state = deep_copy(this.state);
    state.saving = true;
    ALL_PRMS.setDisabled(state, true);
    this.setState(state);
    saveUserPersonalData(this.props.token, data)
      .then(result => {
        const state = deep_copy(this.state);
        state.saving = false;
        state.dirty = false;
        ALL_PRMS.init(state, result, this);
        ALL_PRMS.setDisabled(state, false);
        this.setState(state);
      });
  };

  renderLabelData = (label, elem) => {
    const do_small = this.doSmallLayout();
    const div_style = {
      width: "50%",
      display: "inline-block",
    };

    const span_style = {
      fontSize: "1.1rem",
    };
    const containerStyle = {
      padding: "1rem",
      width: do_small ? "100%" : "50%",
    }
    return (
      <div style={containerStyle}>
        <div style={div_style}>
          <span style={span_style}>{label}:</span>
        </div>
        <div style={div_style}>
          { elem }
        </div>
      </div>
    )
  }

  dismissPopup = () => {
    this.setState({ show_password_popup: false });
  }

  renderFields = () => {
    const save_disable = !this.state.dirty;

    const action_div = this.state.saving
      ? (<Spinner/>) : (<span>Update</span>);
    const span_style = {
      fontSize: "1.1rem",
    };

    const on_password_click = () => {
      this.setState({ show_password_popup: true });
    };

    const widthStyle = {
      width: this.doSmallLayout() ? "100%" : "50%",
    }
    const cityStateStyle = {
      ...widthStyle,
      paddingTop: "0.5rem",
    }
    const is_pershing = this.props.app.wlf.custodian === "PERSHING";
    const addr_prm = is_pershing ? ADDRESS_2 : ADDRESS;

    return (
      <div>
        { this.renderLabelData(
          "Social Security",
          (<span style={span_style}>{SS.getValue(this.state)}</span>) )}
        { this.renderLabelData(
          "Email",
          (<span style={span_style}>{EMAIL.getValue(this.state)}</span>) )}
        { this.renderLabelData(
          "Password",
          (<Action onClick={on_password_click}>Update Password</Action>))}
        <GreyBox>
          { addr_prm.renderInputDiv(this, widthStyle, "Address")}
          <div style={cityStateStyle}>
            <div style={{display: "inline-block", width: "50%"}}>
              { CITY.renderInputDiv(this, { width: "100%"}, "City")}
            </div>
            <div style={{display: "inline-block", paddingLeft: "1rem", width: "15%"}}>
              { STATE.renderInputDiv(this, { width: "100%"}, "State")}
            </div>
            <div style={{display: "inline-block", paddingLeft: "1rem", width: "35%"}}>
              { ZIP.renderInputDiv(this, { width: "100%"}, "Zip")}
            </div>
          </div>
        </GreyBox>
        <div style={{height: "2rem"}}/>
        <GreyBox>
          { PHONE.renderInputDiv(this, widthStyle, "Phone") }
        </GreyBox>
        <div style={{height: "2rem"}}/>
        <div align={"center"}>
          <Action onClick={this.onSave} disabled={save_disable}>
            { action_div }
          </Action>
        </div>
      </div>
    )
  };

  renderSpinner = () => {
    const style = {
      fontSize: "4rem",
      padding: "5rem",
    }
    return (
      <div style={style} align={"center"}>
        <Spinner />
      </div>
    )
  };

  render = () => {

    const loading = this.state.loading;
    const show_pass_dialog = this.state.show_password_popup;
    const dialog = (
      <SetPasswordDialog
        config={this.props.config}
        onDismiss={this.dismissPopup}
        token={this.props.token}/>
    );
    const device = {
      width: this.props.app.width,
    }
    return (
      <div className="container">
        <DashboardContainer
          device={device}
          client={this.props.client}
          title={"Personal Information"}>
          { !loading && this.renderFields() }
          { loading && this.renderSpinner() }
          { show_pass_dialog && dialog }
        </DashboardContainer>>
      </div>
    )
  }
}

export { PersonalInfoDashboard };